import TYPES from '@/modules/shared/types';

// Domain
import { FileRepository } from '../../domain/repository';
import { FileEntity } from '../../domain/entities/file-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class FileHttpRepository implements FileRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/files/`;

  get(file_id: string): Promise<FileEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.concat(file_id))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
